interface GeometricGridBackgroundProps {
  isDark: boolean;
  opacity?: number;
  className?: string;
}

export function GeometricGridBackground({
  isDark,
  opacity = 0.03,
  className = "",
}: GeometricGridBackgroundProps) {
  return (
    <div
      className={`absolute inset-0 pointer-events-none ${className}`}
      style={{ opacity }}
    >
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: `
            linear-gradient(${isDark ? "#fff" : "#000"} 1px, transparent 1px),
            linear-gradient(90deg, ${isDark ? "#fff" : "#000"} 1px, transparent 1px)
          `,
          backgroundSize: "60px 60px",
        }}
      />
    </div>
  );
}
